import { useState } from "react";
import { UserCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { currentImpersonation, stopImpersonation } from "@/services/impersonationService";

/** Shown on every page while signed in as someone else. */
export default function ImpersonationBanner() {
  const state = currentImpersonation();
  const [stopping, setStopping] = useState(false);
  if (!state) return null;
  const who = [state.target.firstname, state.target.lastname].filter(Boolean).join(" ") || state.target.username;
  const admin = [state.original_user?.firstname, state.original_user?.lastname].filter(Boolean).join(" ") || state.original_user?.username;
  return (
    <div className="sticky top-0 z-50 flex flex-wrap items-center justify-center gap-3 bg-amber-500 px-4 py-1.5 text-xs font-medium text-amber-950">
      <UserCheck className="h-4 w-4" />
      <span>
        You are signed in as <b>{who}</b> on behalf of {admin}. Everything you do is recorded as them and in the impersonation log; the session ends after one hour.
      </span>
      <Button size="sm" variant="secondary" className="h-6 px-2 text-xs" disabled={stopping} onClick={() => { setStopping(true); stopImpersonation(); }}>
        {stopping ? "Stopping..." : "Stop and return to my account"}
      </Button>
    </div>
  );
}
